export default function OnboardingScreen1() {
  return (
    <div className="l2f-ob-screen">
      <div className="l2f-ob-eyebrow">01 · THE PROBLEM</div>
      <h1 className="l2f-ob-headline">
        You can't tell how it looks on you until you've bought it.
      </h1>
      <p className="l2f-ob-body">
        Sizes lie. Photos flatter. Returns steal your weekend.
      </p>
      <div className="l2f-ob-visual" aria-hidden>
        <div className="l2f-ob-visual-row">
          <span className="l2f-ob-chip">👗</span>
          <span className="l2f-ob-arrow">→</span>
          <span className="l2f-ob-chip l2f-ob-chip-dim">?</span>
        </div>
      </div>
    </div>
  );
}
